module.exports = __webpack_public_path__ + "media/src/images/icons/download/default-d549c51aba4d6e2c099c43927c565d81.svg";